import {
  META_ATTRIBUTION_WINDOW_1D_CLICK,
  META_ATTRIBUTION_WINDOW_1D_CLICK_1D_VIEW,
  META_ATTRIBUTION_WINDOW_7D_CLICK,
  META_ATTRIBUTION_WINDOW_7D_CLICK_1D_VIEW,
} from "../i18n/keysTranslations.js";

// Same values as the backend (functions/src/utils/metaAttribution.js).
export const META_ATTRIBUTION_WINDOW_DEFAULT = "7D_CLICK_1D_VIEW";

export const META_ATTRIBUTION_WINDOW_OPTIONS = [
  {
    value: META_ATTRIBUTION_WINDOW_DEFAULT,
    labelKey: META_ATTRIBUTION_WINDOW_7D_CLICK_1D_VIEW,
  },
  { value: "7D_CLICK", labelKey: META_ATTRIBUTION_WINDOW_7D_CLICK },
  {
    value: "1D_CLICK_1D_VIEW",
    labelKey: META_ATTRIBUTION_WINDOW_1D_CLICK_1D_VIEW,
  },
  { value: "1D_CLICK", labelKey: META_ATTRIBUTION_WINDOW_1D_CLICK },
];

// Plain values of the utils/constants.js options (that module pulls in UI
// imports, so it can't be loaded by the node unit tests of this helper).
const OBJECTIVES_WITH_PIXEL_CONVERSIONS = ["engagement", "leads", "sales"];
const DESTINATION_TYPE_WEBSITE = "WEBSITE";
const BUYING_TYPE_RESERVED = "RESERVED";

export const getIsValidMetaAttributionWindow = (value) =>
  META_ATTRIBUTION_WINDOW_OPTIONS.some((option) => option.value === value);

/**
 * Visible on auction ad sets that optimize a pixel conversion on a website:
 * engagement, leads or sales. Mirrors the backend rule.
 */
export const getIsMetaAttributionWindowVisible = ({
  objective,
  destinationType,
  buyingType,
}) => {
  if (buyingType === BUYING_TYPE_RESERVED) return false;
  return (
    OBJECTIVES_WITH_PIXEL_CONVERSIONS.includes(objective) &&
    destinationType === DESTINATION_TYPE_WEBSITE
  );
};
